import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ModulesAction from './Modules.Action';
import { history } from 'kts-platform-frame/routes';
import { create } from 'kts-scaffold-framework/utils/form';
import {
    Button,
    Card,
    Layout,
    Icon,
    Form,
    Input,
    Select,
    Row
} from 'antd';
const { Sider } = Layout;
const FormItem = Form.Item;
const Option = Select.Option;
const css = require('./detail.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    type?: number;
    entryIds?: Array<any>;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        if (!this.props.type) {
            ModulesAction.additionalList();
        } else {
            ModulesAction.additionalListSingle({ entryId: this.props.entryIds[0].entryId });
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 24 - 4
            },
        };
        return (
            <Card
                className={css.detail}
            >
                <Form
                    className={css['detail-form']}
                    onSubmit={this.saveInvoiceDetail}
                >
                    {this.getFields()}

                    <div className={css['detail-handle']}>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >保存
                        </Button>
                        <Button onClick={this.hideAside}>取消</Button>
                    </div>
                </Form>
            </Card>
        );
    }

    private getFields() {
        const { getFieldDecorator } = this.props.form;
        const children = [];
        const FormItemValue = ele => {
            if (ele.fieldType === 1) {
                return (<Input/>);
            } else {
                return (
                    <Select>
                        {
                            ele.candidates.map(opts => <Option key={opts.candidateValue}>{opts.candidateName}</Option>)
                        }
                    </Select>
                );
            }
        };
        if (this.modulesState.additionalList) {
            const additionalList = this.modulesState.additionalList;
            additionalList.forEach(ele => {
                children.push(
                    <FormItem
                        label={ele.fieldName}
                        {...this.formItemLayout()}
                    >
                        {
                            getFieldDecorator(ele.fieldId as string, {initialValue: ele.textValue ? ele.textValue : (ele.oldCandidate ? ele.oldCandidate.candidateValue : null )})(
                                FormItemValue(ele)
                            )
                        }
                    </FormItem>
                );
            });
        }
        return children;
    }

    private formItemLayout = () => {
        return {
            labelCol: {
                span: 8
            },
            wrapperCol: {
                span: 24 - 8
            },
        };
    }

    private saveInvoiceDetail = e => {
        e.preventDefault();
        const self = this;
        this.props.form.validateFields((err, values) => {
            console.log(values);
            let addInfs = this.modulesState.additionalList;
            let valuesArr = Object.entries(values);
            addInfs.forEach((ele, index) => {
                if(ele.fieldType === 1) {
                    addInfs[index].textValue = valuesArr[index][1];
                } else {
                    let candidates = addInfs[index]['candidates'];
                    const candidate  = candidates.filter(item => item.candidateValue === valuesArr[index][1]);
                    addInfs[index].candidate = candidate[0];
                }
            });
            const entryIds = self.props.entryIds;
            const options = {
                addInfs,
                entryIds
            };
            ModulesAction.additionalSave(options);
        });
    }

    private hideAside = () => {
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.InvoiceDetail.tsx